import React from 'react';
import useStyles from './CustomFunnel.styles';
import { Tooltip, FunnelChart, Funnel, LabelList } from 'recharts';
import { Box, Typography } from '@material-ui/core';
import { themeColors } from '../../../../styles/themeColors';
import { config } from '../../../../constants/config';

interface IProps {
  data: {
    name: string;
    value: number;
    fill: string;
  }[];
}

const CustomFunnel: React.FC<IProps> = ({ data }) => {
  const styles = useStyles();

  return (
    <Box className={styles.tableContainer}>
      <FunnelChart {...config.funnelDimensions}>
        <Tooltip />
        <Funnel dataKey="value" data={data}>
          {data.map(
            ({ name, value }) =>
              value && (
                <LabelList
                  key={name}
                  position="center"
                  stroke="none"
                  fill={themeColors.textSecondary}
                  dataKey="value"
                />
              ),
          )}
        </Funnel>
      </FunnelChart>
      {data.map(({ name, fill }) => (
        <FunnelLegend key={name} label={name} fill={fill} />
      ))}
    </Box>
  );
};

export default CustomFunnel;

interface IFunnelLegendProps {
  fill: string;
  label: string;
}

const FunnelLegend: React.FC<IFunnelLegendProps> = ({ fill, label }) => {
  const styles = useStyles();

  return (
    <Box className={styles.legendItemContainer}>
      <Box className={styles.legendColorBox} bgcolor={fill} />
      <Typography variant="subtitle2">{label}</Typography>
    </Box>
  );
};
